import { CriteriaType } from '@constants'
import { GETStoredSearchFilterType } from '@types'

import { formatStoredValue } from './formatStoredValue'

export const mapStoredSearchFilterToCriteria = (
  storedSearchFilter: GETStoredSearchFilterType
): CriteriaType => {
  return {
    codeCriteria: storedSearchFilter.searchFilterObject.code,
    title: storedSearchFilter.searchFilterObject.title,
    id: storedSearchFilter.searchFilterObject.id,
    isPinning: storedSearchFilter.searchFilterObject.isPinning,
    order: storedSearchFilter.searchFilterObject.order,
    visibility: storedSearchFilter.searchFilterObject.visibility,
    storedValues: storedSearchFilter.storedValues.map(value => ({
      ...value.valueObject,
      value: formatStoredValue(value),
      searchRule: value.searchRule,
    })),
  }
}
